import { call, select, delay } from 'redux-saga/effects';
import get from 'lodash/get';
import { getGallectionById } from '../selectors';
import { request } from '../../xhr';
import { getGallectionType } from '../helpers';
function* setGallectionDescription(action) {
    yield delay(500); // + takeLatest = debounced
    const { folderId , description  } = action.payload;
    const gallection = yield select(getGallectionById, folderId);
    if (!gallection) {
        return;
    }
    var _getGallectionType;
    const params = {
        type: (_getGallectionType = getGallectionType(gallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        folderid: gallection.folderId,
        name: gallection.name,
        description,
        cover_deviationid: gallection.type === 'stash' ? undefined : get(gallection, 'thumb.deviationId')
    };
    yield call(request, {
        method: 'post',
        url: 'gallection/folders/update',
        data: params
    });
}
export default setGallectionDescription;
